import React, { FC, ReactNode } from 'react'
import { PageBox } from './styled'

interface PageProps {
	children: ReactNode
	page?: String
}

const Page: FC<PageProps> = ({ children }: PageProps) => {
	return <PageBox>{children}</PageBox>
}

export default Page
